import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
//import Genres from '../genres/genres';
//import moment from 'moment';
//import ScheduleAdd from '../schedule/add';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
//import Form from 'react-bootstrap/Form';
//import Modal from 'react-bootstrap/Modal';

import './notifications.css';

export default class Notifications extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			show: false,
			NotifyListener: null,

		};
		//this.close = this.close.bind(this);
  };

  async componentDidMount() {
		/*
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});
		*/

		const NotifyListener = EventEmitter.addListener('/notifications',async (data) => {
			/*
			let params = new URLSearchParams();
			params.append('uid', data.uid);
			const x = await postApi('/api/v2/donation', params);
			if( x.status === 200 ) {
				if( x.data.length === 1 && x.data[0].length === 1 ) {
					
					window.open(x.data[0][0].option1, "_blank", "noreferrer");
				} else {
					this.setState({show: true, donations: x.data});
				}
			}*/

		}); this.setState({NotifyListener});
	}

	componentWillUnmount() {
		if( this.state.NotifyListener ) this.state.NotifyListener.remove();
	}

	/*close() {
		this.setState({ show: false });
	}*/

	render() {
		//const user = this.context;
		
		return (
			<div className="notifications">
				<div className="notifications-header">
					Paul Jenkins is live
					<span className="float-right"><FontAwesomeIcon icon="times" /></span>
				</div>
				<div className="notifications-body">
					
					<Row className="gx-0">
						<Col xs={5}>
							<Link to={'/clubbers'}><img src={`https://mix365.co.uk/images/live/61.png?d=${Math.floor(Date.now()/1000)}`} alt="profile cover" width="100%" /></Link>
						</Col>
						<Col className="notifications-body-inner">
							Paul Jenkins is now streaming live on mix365 clubbers<br /><br />
							<Link to={'/clubbers'}><Button size="sm">Watch Now</Button></Link>
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

